import { Check, Sprout } from 'lucide-react';

import { cn } from '@apps/web/lib/utils';

// A compact recorded state shown in place of an ask_user_question card after
// submit. Regular chat uses a check; Teach Phoebe keeps the sprout brand mark.

export function TeachPhoebeThankYou({
    label = 'Answer recorded',
    showSprout,
    variant = 'card',
}: {
    readonly label?: string;
    readonly showSprout: boolean;
    readonly variant?: 'card' | 'chip';
}) {
    const Icon = showSprout ? Sprout : Check;

    if (variant === 'chip') {
        return (
            <div className="user-question-recorded-state border-training-surface-border bg-training-surface inline-flex max-w-full items-center gap-1.5 rounded-xl border px-3 py-2">
                <Icon
                    className="text-training-accent h-3.5 w-3.5 shrink-0"
                    aria-hidden={true}
                />
                <p className="text-training-strong truncate text-sm leading-4 font-medium">
                    {label}
                </p>
            </div>
        );
    }

    return (
        <div className="user-question-recorded-state flex h-16 items-center gap-3 px-4">
            <span
                className={cn(
                    'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border',
                    showSprout
                        ? 'border-training-surface-border bg-background text-training-accent'
                        : 'border-border bg-background text-foreground',
                )}
            >
                <Icon
                    className={showSprout ? 'h-4 w-4' : 'h-3.5 w-3.5'}
                    strokeWidth={showSprout ? 2 : 2.5}
                />
            </span>
            <div className="min-w-0">
                <p className="text-foreground truncate text-sm font-medium">
                    Answer recorded
                </p>
                <p className="text-muted-foreground truncate text-xs">
                    {showSprout
                        ? 'Thanks for teaching Phoebe.'
                        : 'Phoebe is continuing.'}
                </p>
            </div>
        </div>
    );
}
